import type { ChangeRequest, JobDescription } from '../types'

/**
 * A request is written against the version of the role that existed when the
 * manager raised it. If the role has moved on since, approving would silently
 * overwrite whoever edited it in the meantime, so it is blocked (FR-23).
 */
export const isStale = (jd: JobDescription, request: ChangeRequest) =>
  jd.version !== request.baseVersion

/** One wording, used by the screen and by the API, so the two cannot drift. */
export const staleMessage = (jd: JobDescription, request: ChangeRequest) =>
  `“${jd.title}” has changed since this request was raised. It is now v${jd.version}, and the request was written against v${request.baseVersion}. Approving would undo that newer edit, so ask ${request.requestedBy} to redo the request against the current version.`
